/** The logistics page's query keys — one set for web and mobile, so a shared
 *  hook and either app's own reads address the same cache entries. */
export const logisticsKeys = {
  /** A site's logistics payload — KPIs, deliveries, stock, waste. */
  page: (siteId: string) => ['logistics', siteId] as const,
  /** The board's own column set. */
  statuses: (siteId: string) => ['logistics-statuses', siteId] as const,
  /** The cheap revision probe a page polls to learn it is stale. */
  revision: (siteId: string) => ['logistics-revision', siteId] as const,
  /** A site's supplier list. */
  suppliers: (siteId: string) => ['logistics-suppliers', siteId] as const,
};
